<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'PRICING.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'PRICING.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'PRICING.TEXT' | translate }}</p>
      <p class="ph-pricing-trial">{{ 'HOME.SECTION_PAYMENT_TEXT' | translate }}</p>
    </div>
  </section>

  <section id="pricing" class="ph-section">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'HOME.SECTION_PAYMENT_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'PRICING.SECTION_PAYMENT_TEXT' | translate }}</p>
      </div>

      <div class="ph-pricing__grid">
        <article
          *ngFor="let plan of plans"
          class="ph-pricing-card"
          [class.ph-pricing-card--featured]="plan.featured"
          [class.ph-pricing-card--dark]="plan.dark">
          <span *ngIf="plan.featured" class="ph-pricing-card__ribbon">{{ 'PRICING.RECOMMENDED' | translate }}</span>

          <div class="ph-pricing-card__name">{{ plan.titleKey | translate }}</div>
          <span *ngIf="plan.badgeKey" class="ph-pricing-card__badge">{{ plan.badgeKey | translate }}</span>

          <div class="ph-pricing-card__price">
            <ng-container *ngIf="plan.staticPriceKey; else subscriptionPrice">
              <span>{{ plan.staticPriceKey | translate }}</span>
            </ng-container>
            <ng-template #subscriptionPrice>
              <ng-container *ngIf="plan.subscriptionKey && getSubscriptionPriceDetails(plan.subscriptionKey) as price">
                <span>{{ price.subscriptionPrice || '0.00' }}</span>
                <span class="ph-pricing-card__suffix">
                  {{ price.subscriptionCurrency || 'RON' }} {{ plan.priceLabelKey | translate }}
                </span>
              </ng-container>
            </ng-template>
          </div>

          <p class="ph-pricing-card__desc">{{ plan.descKey | translate }}</p>

          <ul class="ph-pricing-card__features">
            <li *ngFor="let featureKey of plan.featureKeys">{{ featureKey | translate }}</li>
          </ul>

          <div *ngIf="plan.noteKeys?.length" class="ph-pricing-card__notes">
            <p *ngFor="let noteKey of plan.noteKeys">{{ noteKey | translate }}</p>
          </div>

          <a
            *ngIf="plan.contactCta"
            routerLink="/contact"
            class="ph-btn ph-btn--block ph-btn--lg"
            [class.ph-btn--brand]="plan.featured"
            [class.ph-btn--accent]="plan.dark"
            [class.ph-btn--dark]="!plan.featured && !plan.dark">
            {{ plan.ctaKey | translate }}
          </a>
          <a
            *ngIf="!plan.contactCta"
            [href]="planCtaHref(plan)"
            class="ph-btn ph-btn--block ph-btn--lg"
            [class.ph-btn--brand]="plan.featured"
            [class.ph-btn--accent]="plan.dark"
            [class.ph-btn--dark]="!plan.featured && !plan.dark">
            {{ plan.ctaKey | translate }}
          </a>
        </article>
      </div>

      <div class="ph-pricing-compare-toggle">
        <button type="button" class="ph-btn ph-btn--outline" (click)="toggleCompareTable()">
          {{ (showCompareTable ? 'PRICING.HIDE_COMPARE' : 'PRICING.SHOW_COMPARE') | translate }}
        </button>
      </div>

      <div *ngIf="showCompareTable" class="ph-pricing-compare">
        <h3 class="ph-pricing-compare__title">{{ 'PRICING.COMPARE_TITLE' | translate }}</h3>
        <div class="ph-pricing-compare__scroll">
          <table class="ph-pricing-compare__table">
            <thead>
              <tr>
                <th scope="col">{{ 'PRICING.FUNCTIONALITIES' | translate }}</th>
                <th scope="col">{{ 'PRICING.START_PLAN_TITLE' | translate }}</th>
                <th scope="col">{{ 'PRICING.SMART_PLAN_TITLE' | translate }}</th>
                <th scope="col">{{ 'PRICING.SCALE_PLAN_TITLE' | translate }}</th>
                <th scope="col">{{ 'PRICING.MANAGEMENT_PROPERO_TITLE' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of compareRows">
                <th scope="row">{{ row.labelKey | translate }}</th>
                <td *ngFor="let valueKey of row.valueKeys">
                  <span *ngIf="valueKey; else dash">{{ valueKey | translate }}</span>
                  <ng-template #dash>—</ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <p class="ph-section__eyebrow">{{ 'PRICING.ADDITIONAL_DETAILS' | translate }}</p>
        <h2 class="ph-section__title">{{ 'PRICING.FAQ' | translate }}</h2>
      </div>

      <div class="ph-faq">
        <div
          *ngFor="let item of pricingFaqItems; let i = index"
          class="ph-faq__item"
          [class.ph-faq__item--open]="openFaqIndex === i">
          <button
            type="button"
            class="ph-faq__trigger"
            (click)="toggleFaq(i)"
            [attr.aria-expanded]="openFaqIndex === i">
            <span>{{ item.questionKey | translate }}</span>
            <i class="lni lni-chevron-down ph-faq__chevron" [class.ph-faq__chevron--open]="openFaqIndex === i"></i>
          </button>
          <div class="ph-faq__panel" *ngIf="openFaqIndex === i">
            <p>{{ item.answerKey | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>

        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="pricing-contact-name">{{ 'HOME.NAME' | translate }}</label>
          <input
            id="pricing-contact-name"
            type="text"
            name="name"
            [(ngModel)]="contactItem.subject"
            required
            [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="pricing-contact-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input
            id="pricing-contact-email"
            type="email"
            name="email"
            [(ngModel)]="contactItem.email"
            required
            email
            [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="pricing-contact-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea
            id="pricing-contact-message"
            name="message"
            rows="4"
            [(ngModel)]="contactItem.content"
            required
            [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button
          type="submit"
          class="ph-btn ph-btn--accent ph-btn--block ph-btn--lg"
          [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
      </form>
    </div>
  </section>
</div>
